import type { TranslateOptions } from '../types';

/**
 * 创建翻译任务的能力
 */
export interface CreateSyncTranslateTaskService {
    /**
     * 创建翻译任务
     * @example
     * ```
     * POST:  /ai/task
     * body: {
     *      "taskId": "123",
     *      "translateOptions": {
     *          "text": "Hello, world!",
     *          "targetLanguage": "en",
     *      }
     * }
     * ```
     * @param taskId 任务ID
     * @param translateOptions 翻译任务选项
     */
    createTranslateTask: (taskId: string, translateOptions: TranslateOptions) => Promise<void>;
}

export const CreateSyncTranslateTaskService = Symbol('CreateSyncTranslateTaskService');
